import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/EnvironmentConfigurationTable.css';
import EnvironmentConfigurationTableRow from './EnvironmentConfigurationTableRow';

EnvironmentConfigurationTable.propTypes = {
    configPairs: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

function EnvironmentConfigurationTable(props) {
    const {
        configPairs,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="settings-detail-tab--env-configuration">
            <div className="field">
                <span className="field--key">{t('settings.env-configuration.title')}</span>
                <div className="detail-list">
                    <div className="detail-list-row detail-list-header">
                        <div className="config-cell env-configuration-table-row--header--config-key">{t('settings.env-configuration.config-key')}</div>
                        <div className="config-cell env-configuration-table-row--header--value">{t('settings.env-configuration.value')}</div>
                    </div>
                    {configPairs.map(([configKey, value]) => (
                        <EnvironmentConfigurationTableRow
                            key={configKey}
                            configKey={configKey}
                            value={value}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default EnvironmentConfigurationTable;
